import React from "react";
import ListingCard, { ListingCardSkeleton } from "@/components/listings/ListingCard";
import { LISTING } from "@/constants/testIds";
import { PackageOpen } from "lucide-react";

export default function ListingGrid({ listings = [], loading, empty = "No listings found.", showOpenHome = false }) {
  if (loading) {
    return (
      <div data-testid={LISTING.grid} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <ListingCardSkeleton key={i} />
        ))}
      </div>
    );
  }
  if (!listings.length) {
    return (
      <div data-testid={LISTING.emptyState} className="rounded-2xl border border-dashed border-soft bg-white p-14 text-center">
        <PackageOpen className="w-8 h-8 mx-auto text-slate-300" />
        <h3 className="mt-3 font-display font-bold text-lg text-slate-800">{empty}</h3>
        <p className="text-sm text-slate-500 mt-1">Try adjusting filters or check back soon.</p>
      </div>
    );
  }
  return (
    <div data-testid={LISTING.grid} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {listings.map((l) => <ListingCard key={l.id} listing={l} showOpenHome={showOpenHome} />)}
    </div>
  );
}
